// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/wind_shield.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/Background/Map.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/Background/container.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_main_section__fs-aF {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  max-width: 100%;
  margin: 0;
  padding: 0 0 4em;

  .home_left_section__\\+s9bw {
    margin: 4rem 0 2rem;

    & h6 {
      color: #fff;
      font-family: Inter;
      font-size: 1.8rem;
      font-weight: 700;
    }

    & p {
      color: #fff;
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }

    & button {
      color: #fff;
      font-family: Inter;
      font-size: 12px;
      font-weight: 400;
      display: flex;
      width: 148px;
      height: 50px;
      padding: 10px 19px;
      gap: 3px;
      border: none;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.18);
      backdrop-filter: blur(3.5px);
    }
  }

  /* 
  .right_section {
    margin: 4rem 0 0 2rem;
    display: flex;
    width: 100%;
    height: auto;
    padding: 28px 31px;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.6rem;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.23);
    backdrop-filter: blur(6.5px);

    & p {
      color: #fff;
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }

    & span {
      color: #fff;
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }
  } */
}

Container{
  padding: 0;
}

.home_hero_section__BEXKz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  background-color: #212121;
  max-width: 100%;
  padding-top: 5rem;

  & h6 {
    color: #fff;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & p {
    color: #fff;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 400;
  }
}

.home_container_section__qeP3P {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  max-width: 100%;

  .home_left_section__\\+s9bw {
    width: 85%;
    margin: 4rem 0 0;

    & h6 {
      color: #fff;
      font-family: Inter;
      font-size: 2rem;
      font-weight: 700;
    }

    & p {
      color: #fff;
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 400;
    }

    & span {
      color: #fff;
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }
  }

  .home_right_section__Wxurd {
    margin: 4rem 0 ;
    width: 100%;
    height: auto;
    padding: 0 31px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;

    & p {
      color: #fff;
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 400;
    }
  }
}

.home_solution_section__ujD7M {
  margin: 4rem 0;

  & h6 {
    color: #242020;
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & span {
    color: #62677a;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }

  & a {
    color: var(--primary-color);
    text-decoration: none;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }

  & p {
    padding-top: 0.6rem;
    color: #242020;
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 500;
  }
}

/* ----------media-queries------------ */

@media screen and (max-width: 568px) {
  .home_main_section__fs-aF {
    padding: 1rem 0;
    height: auto;

    .home_right_section__Wxurd {
      padding: 1rem;
      margin: 0 0;
    }
  }
  .home_main_section__fs-aF .home_left_section__\\+s9bw {
    margin: 0.8rem 0 1rem;

    & button {
      width: 100%;
    }
  }

  .home_hero_section__BEXKz {
    display: none;
  }

  .home_container_section__qeP3P .home_right_section__Wxurd {
    padding: 0;
    margin: 0;
  }
  .home_container_section__qeP3P .home_left_section__\\+s9bw {
    width: 100%;
    margin: 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/home.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAmE;EACnE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;;EAEhB;IACE,mBAAmB;;IAEnB;MACE,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,QAAQ;MACR,YAAY;MACZ,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,qCAAqC;MACrC,4BAA4B;IAC9B;EACF;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2BG;AACL;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yDAA0D;EAC1D,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iBAAiB;;EAEjB;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,yDAAiE;EACjE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;;EAEf;IACE,UAAU;IACV,gBAAgB;;IAEhB;MACE,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,WAAW;MACX,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,wCAAwC;;AAExC;EACE;IACE,eAAe;IACf,YAAY;;IAEZ;MACE,aAAa;MACb,WAAW;IACb;EACF;EACA;IACE,qBAAqB;;IAErB;MACE,WAAW;IACb;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/wind_shield.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: auto;\n  max-width: 100%;\n  margin: 0;\n  padding: 0 0 4em;\n\n  .left_section {\n    margin: 4rem 0 2rem;\n\n    & h6 {\n      color: #fff;\n      font-family: Inter;\n      font-size: 1.8rem;\n      font-weight: 700;\n    }\n\n    & p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n\n    & button {\n      color: #fff;\n      font-family: Inter;\n      font-size: 12px;\n      font-weight: 400;\n      display: flex;\n      width: 148px;\n      height: 50px;\n      padding: 10px 19px;\n      gap: 3px;\n      border: none;\n      justify-content: center;\n      align-items: center;\n      border-radius: 4px;\n      background: rgba(255, 255, 255, 0.18);\n      backdrop-filter: blur(3.5px);\n    }\n  }\n\n  /* \n  .right_section {\n    margin: 4rem 0 0 2rem;\n    display: flex;\n    width: 100%;\n    height: auto;\n    padding: 28px 31px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.6rem;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.23);\n    backdrop-filter: blur(6.5px);\n\n    & p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n\n    & span {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n  } */\n}\n\nContainer{\n  padding: 0;\n}\n\n.hero_section {\n  background-image: url(\"/public/images/Background/Map.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  background-color: #212121;\n  max-width: 100%;\n  padding-top: 5rem;\n\n  & h6 {\n    color: #fff;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & p {\n    color: #fff;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 400;\n  }\n}\n\n.container_section {\n  background-image: url(\"/public/images/Background/container.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: auto;\n  max-width: 100%;\n\n  .left_section {\n    width: 85%;\n    margin: 4rem 0 0;\n\n    & h6 {\n      color: #fff;\n      font-family: Inter;\n      font-size: 2rem;\n      font-weight: 700;\n    }\n\n    & p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 400;\n    }\n\n    & span {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n  }\n\n  .right_section {\n    margin: 4rem 0 ;\n    width: 100%;\n    height: auto;\n    padding: 0 31px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    border-radius: 10px;\n\n    & p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 400;\n    }\n  }\n}\n\n.solution_section {\n  margin: 4rem 0;\n\n  & h6 {\n    color: #242020;\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & span {\n    color: #62677a;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n\n  & a {\n    color: var(--primary-color);\n    text-decoration: none;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n\n  & p {\n    padding-top: 0.6rem;\n    color: #242020;\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 500;\n  }\n}\n\n/* ----------media-queries------------ */\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    padding: 1rem 0;\n    height: auto;\n\n    .right_section {\n      padding: 1rem;\n      margin: 0 0;\n    }\n  }\n  .main_section .left_section {\n    margin: 0.8rem 0 1rem;\n\n    & button {\n      width: 100%;\n    }\n  }\n\n  .hero_section {\n    display: none;\n  }\n\n  .container_section .right_section {\n    padding: 0;\n    margin: 0;\n  }\n  .container_section .left_section {\n    width: 100%;\n    margin: 1rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `home_main_section__fs-aF`,
	"left_section": `home_left_section__+s9bw`,
	"hero_section": `home_hero_section__BEXKz`,
	"container_section": `home_container_section__qeP3P`,
	"right_section": `home_right_section__Wxurd`,
	"solution_section": `home_solution_section__ujD7M`
};
export default ___CSS_LOADER_EXPORT___;
